// extracted by mini-css-extract-plugin
export var progressBar = "_o1-0";
export var progressBarInner = "_o1-1";